import { PropsWithChildren } from 'react';

import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';

import { currentActivityAtom } from '../atoms/activity/currentActivity';
import { currentUserIdAtom } from '../atoms/global/user';
import { swingThreadToggleAtom } from '../atoms/swing/swingThreads';
import { corridorsAtom } from '../atoms/user/corridors';
import { activeUserSettingsAtom, userLocaleAtom, userSettingsAtom } from '../atoms/user/user';
import {
    axisFocusIdAtom,
    pathsAtom,
    selectedVisualizationAxesAtom,
    showVisualizationsAtom,
    swingPlanesAtom,
    traceAtom,
} from '../atoms/user/visualizations';

export const UserScope = ({ children }: PropsWithChildren) => {
    const currentUserId = useAtomValue(currentUserIdAtom);
    return (
        <ScopeProvider
            key={currentUserId}
            atoms={[
                swingThreadToggleAtom,
                currentActivityAtom,
                corridorsAtom,
                userSettingsAtom,
                activeUserSettingsAtom,
                userLocaleAtom,
                selectedVisualizationAxesAtom,
                traceAtom,
                swingPlanesAtom,
                pathsAtom,
                showVisualizationsAtom,
                axisFocusIdAtom,
            ]}
        >
            {children}
        </ScopeProvider>
    );
};

export const withUserScope = <C extends React.ComponentType<any>>(Component: C) => {
    type Props = React.ComponentProps<C>;

    const Wrapped = (props: Props) => (
        <UserScope>
            <Component {...props} />
        </UserScope>
    );

    Wrapped.displayName = `withUserScope(${Component.displayName ?? Component.name ?? 'Component'})`;
    return Wrapped;
};
